import { get } from "lodash";
import { SCREEN_EVENTS } from "utils/constants";

// A screen runs in a sandboxed iframe: it cannot reload the page, so this is how
// it asks the runtime to re-enter the step it is displaying. Re-entering replays
// the entry connectors, which is the only way to rebuild data they produced and
// that has since gone stale. The runtime stays unaware of why a screen asks.
export const isReloadStepEvent = (data) =>
  get(data, "source") === SCREEN_EVENTS.SOURCE &&
  get(data, "type") === SCREEN_EVENTS.TYPES.RELOAD_STEP;
